import React from 'react';
import ValidationsContext from './validationsContext';


const validationsState = props => {
    ///// expresiones regulares Para verificar que se cumpla x condicion ///////////
    const eMailPattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    const spacesAndLetters = new RegExp("^[a-zA-Z\\s]+$")
    const repeatedSpaces = new RegExp(/(\s{2,})/g);
    const hexa16length = new RegExp(/^[a-fA-F0-9]{16,16}$/)
    const hexa6length = new RegExp(/^[a-fA-F0-9]{32,32}$/)
    const hexalength = new RegExp(/^[a-fA-F0-9]{6,6}$/)
    const spacesLettersAndNumbers = new RegExp("^[a-zA-Z0-9\\s]+$");
    const only11Numbers = new RegExp(/^[0-9]{11,11}$/)
    const wordsNumbersAndDashes = RegExp(/^[-_a-zA-Z0-9.]+$/)
    
    const validateApplicationName = (x) => {
        if (!wordsNumbersAndDashes.test(x)) {
            return 'Solo se permiten letras, numeros y guiones'
        }{
            return ""
        }
    } 

    const notEmpty = (str) => {
        if (str==undefined || str == null) return "campo obligatorio"
        const x = str.trimStart()
        return !(!x || x.length === 0)? "":"Campo obligatorio*"
    }

    const validateCuit = (cuit) => {
        if (!only11Numbers.test(cuit)) {
            return 'No es un cuit!'
        }{
            return ""
        }
    }

    const validateDirecciones = (dir) => {
        if (!spacesLettersAndNumbers.test(dir)) {
            return 'No se permiten signos'
        }else if (dir.length<2){
            return "Direccion demasiado corta"
        }else{
            return ""
        }
    }

    /**
     * @param {*} num codigo de verificacion de un dispositivo
     */
    const validateDispositivoCodigoVerificacion = (num) => {
        if (!hexa6length.test(num)) {
            return 'Codigo Invalido!'
        }/* else if (nombre.length === 0) {
                return "Este campo es obligatorio"
            }*/ {
            return ""
        }
    }

    /**
     * @param {*} nombre nombre de dispositivo
     * @return {*} string de error especifico
     */
    const validateDispositivoNombre = (nombre) => {
        if (!nombre || nombre.length === 0) {
            return "Este campo es obligatorio"
        } else if (nombre.length <= 3) {
            return 'texto muy corto!'
        } else 
            return ""
    }

    /**
     * 
     * @param {inp} id GateWayLora
     */
    const validateIdLora = (inp)=>{
        // ac1f09fffe014937
        if(notEmpty(inp).length>0) return notEmpty(inp);
        inp=inp.trim();
        if (inp.length!= 16) return "se esperan 16 caracteres exa"
        return "";
    }

    /**
     * @param {*} num numero de serie de un dispositivo
     */
    const validateDispositivoNumeroSerie = (num) => {
        if (!hexa16length.test(num)) {
            return 'Numero Invalido!'
        } else {
            return ""
        }
    }

    const validateDispositivoNumeroSerieField = (num) => {
        if (!hexalength.test(num)) {
            return 'Numero Invalido!'
        } else {
            return ""
        }
    }

    /**
     * @param {*} cod codigo de area
     * @param {*} num numero de telefono
     * @return {*} string de error especifico
     */
    const validateNumeroTelefono = (cod, num) => {
        if (num.length > 8) {
            return "numero demasiado largo"
        } else if (num.length < 6) {
            return "numero demasiado corto"
        } else if (cod.length === 2 && (cod.length + num.length > 10)) {
            return "numero demasiado largo"
        } else if (cod.length === 3 && (cod.length + num.length > 10)) {
            return "numero demasiado largo"
        } else if (cod.length === 4 && (cod.length + num.length > 10)) {
            return "numero demasiado largo"
        } else if (cod.length + num.length < 10) {
            return "numero demasiado corto"
        }
        return ""
    }


    /**
     * @param {*} cod codigo de area
     * @param {*} num numero de telefono
     * @return {*} string de error especifico
     */
    const validateCodigoArea = (cod, num) => {
        if (cod.length > 4) {
            return "codigo demasiado largo"
        } else if (cod.length < 2) {
            return "codigo demasiado corto"
        }  else if (num.length === 8 && (cod.length + num.length > 10)) {
            return "codigo demasiado largo"
        } else if (num.length === 7 && (cod.length + num.length > 10)) {
            return "codigo demasiado largo"
        } else if (num.length === 6 && (cod.length + num.length > 10)) {
            return "codigo demasiado largo"
        } else if (cod.length < 4 && cod.length + num.length < 10) {
            return "codigo demasiado corto"
        } 
        return ""
    }



    const validatePassword = (pass) => {
        if (pass.length <= 4 && pass.length > 0) {
            return 'Contraseña demasiado corta'
        } else if (pass.length === 0) {
            return "Este campo es obligatorio"
        } else if (pass.length > 18) {
            return "Contraseña demasiado larga"
        } else {
            return ""
        }
    }

     
    const validateRepeatPassword = (pass, firstPassword) => {
        if (pass.length <= 4 && pass.length > 0) {
            return 'Contraseña demasiado corta'
        } else if (pass.length === 0) {
            return "Este campo es obligatorio"
        }  else if (pass.length > 18) {
            return "Contraseña demasiado larga"
        } else if(pass!== firstPassword){
            return "Las contraseñas no coinciden"
        }
        else {
            return ""
        }
    }

    /**
     * @param {*} nombre nombre de usuario
     * @return {*} string de error especifico
     */
    const validateUsername = (nombre) => {
        if (nombre.length <= 2 && nombre.length > 0) {
            return 'Nombre muy corto!'
        } else if (nombre.length === 0) {
            return "Este campo es obligatorio"
        } else if (nombre.length > 2 && (!spacesAndLetters.test(nombre))) {
            return "Solo se permiten letras y espacios"
        } else if (repeatedSpaces.test(nombre)) {
            return "El nombre no debe poseer espacios seguidos"
        } else if (nombre.length > 24) {
            return "No debe superar los 24 caracteres"
        } else {
            return ""
        }
    }

    /**
     * @param {*} eMail mail en form de registro
     * @return {*} string de error especifico
     */
    const validateeMail = (eMail) => {
        if (!eMailPattern.test(eMail)) {
            return 'ingrese un eMail valido'
        } else {
            return ""
        }
    }

    function validateUrl (string) {
        if(notEmpty(string).length>0) return notEmpty(string);
        string=string.trim();

        if (string.length<12) return "Url no valida o demaciado corta";
        let givenURL ;
        try {
            givenURL = new URL (string);
            if (givenURL.protocol=='http:' || givenURL.protocol=='https:'){
                let host = givenURL.host;
                let path = givenURL.pathname;
                if (host && host.length>4 && path && path.length>3)
                    return ""
                else return "El host o path son demaciado cortas"
            } else
                return "protocolo no valido";

        } catch (error) {
            return "No es una url valida"; 
        }
    }


    /**
     * Validamos que no exista ningun error
     * es recomendable poner null en el caso base en donde no se valido aun
     * @param {*} errors 
     * @returns 
     */
    const validateForm = (errors) => {
        let valid = true;
        Object.values(errors).forEach(val => (val==null || val.length > 0) && (valid = false));
        return valid;
    };

    const getErrorForm = (errors, mapa) => {
        let salida = []; // {name, value}
        const gnPair = (name,value)=>({name,value});

        Object.keys(errors).forEach (atributo=>{
            let val = errors[atributo];
            if (val === null || val ===undefined) return salida.push(gnPair(mapa[atributo], 'Valor no definido'));
            if (val.length>0 ) return salida.push(gnPair(mapa[atributo],val));
        }) 
        return salida;
    };

    
    return (
        <ValidationsContext.Provider
            value={{
                getErrorForm,
                notEmpty,
                validateApplicationName,
                validateCodigoArea,
                validateCuit,
                validateDirecciones,
                validateDispositivoCodigoVerificacion,
                validateDispositivoNombre,
                validateDispositivoNumeroSerie,
                validateDispositivoNumeroSerieField,
                validateeMail,
                validateForm,
                validateIdLora,
                validateNumeroTelefono,
                validatePassword,
                validateRepeatPassword,
                validateUrl,
                validateUsername,
            }}
        >{props.children}

        </ValidationsContext.Provider>
    )
}
export default validationsState;
